export const games = [
    {
      id: 1,
      name: "Kingdom Hearts HD 1.5 + 2.5 ReMIX",
      yearsPlayed: ["2017", "2018", "2019", "2020"],
      releaseYear: "2017",
      //image: "/covers/kh1525_cover.jpg",
      //image: "https://image.api.playstation.com/cdn/UP0082/CUSA05933_00/Mcd5L82dShQ7n5zWfBVNKMAfPgl1kkSz.png",
      image: "https://preview.redd.it/i-thought-the-default-steam-art-for-hd-1-5-2-5-remix-was-v0-7ar5w9fjzxcd1.png?width=600&format=png&auto=webp&s=3d27031c9b531d7b75d37e3fdd72498870826154",
      link: "https://amzn.to/4a8mck5"
    },
    {
      id: 2,
      name: "Bloodborne",
      yearsPlayed: ["2017", "2022", "2023", "2024"],
      releaseYear: "2015",
      image: "https://image.api.playstation.com/vulcan/img/rnd/202010/2614/Sy5e8DmeKIJVjlAGraPAJYkT.png",
      link: "https://amzn.to/4aawZun"
    },
    {
      id: 3,
      name: "Warframe",
      yearsPlayed: ["2017"],
      releaseYear: "2013",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202401/3018/6005ee4b822b3458fba98170145348f31869d3a771f55ab4.png",
      link: "https://store.playstation.com/en-us/product/UP2097-PPSA01737_00-WARFRAMEPS500000"
    },
    {
      id: 4,
      name: "Outlast",
      yearsPlayed: ["2018"],
      releaseYear: "2013",
      //image: "/covers/outlast_cover.jpg",
      image: "https://cdn2.steamgriddb.com/thumb/25644b95de790aea9e0cb3d19b17a945.jpg",
      link: "https://amzn.to/4fPiFZ6"
    },
    {
      id: 5,
      name: "God of War",
      yearsPlayed: ["2018"],
      releaseYear: "2018",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/vulcan/img/rnd/202010/2217/p3pYq0QxntZQREXRVdAzmn1w.png",
      link: "https://amzn.to/3DHQX3s"
    },
    {
      id: 6,
      name: "Darksiders II",
      yearsPlayed: ["2018"],
      releaseYear: "2012",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/vulcan/img/rnd/202010/1408/unktZ4u5hcQIQtoC6P3BSmrf.jpg",
      link: "https://amzn.to/4h2p3gP"
    },
    {
      id: 7,
      name: "Grand Theft Auto V",
      yearsPlayed: ["2019", "2021"],
      releaseYear: "2013",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/cdn/UP1004/CUSA00419_00/bTNSe7ok8eFVGeQByA5qSzBQoKAAY32R.png",
      link: "https://amzn.to/4h56VTE"
    },
    {
      id: 8,
      name: "The Dark Anthology: Man of Medan",
      yearsPlayed: ["2019"],
      releaseYear: "2019",
      //image: "/covers/outlast_cover.jpg",
      image: "https://cdn11.bigcommerce.com/s-xs1cevxe43/images/stencil/original/products/2395/9363/ECOM_Product_Tiles_Packshot_2D_AGNOSTIC_UNRATED_EN_USTDP_MOM.jpg80__75114.1633713199.png?c=2",
      link: "https://store.steampowered.com/app/939850/The_Dark_Pictures_Anthology_Man_of_Medan/"
    },
    {
      id: 9,
      name: "The Outer Worlds",
      yearsPlayed: ["2020"],
      releaseYear: "2019",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/vulcan/img/cfn/11307wMjfgx5P1og84rPU_f7JRWHhWnbDWqpjfHfMPGtwxykE12sZmu8C7n0XrhYwLTdxcQyXwH4Jy4JpS67tQd5Gl0Kd5Rz.png",
      link: "https://amzn.to/3C0aDPm"
    },
    {
      id: 10,
      name: "Outlast II",
      yearsPlayed: ["2020"],
      releaseYear: "2017",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/cdn/UP2113/CUSA06623_00/5vXtP0O5fmnnyrNnWAinTz57d04szG3b.png",
      link: "https://amzn.to/4fPiFZ6"
    },
    {
      id: 11,
      name: "Spider-Man",
      yearsPlayed: ["2020"],
      releaseYear: "2018",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202011/0402/C784xeOFo2wViCf4m5bxgoeH.png",
      link: "https://amzn.to/40myEJM"
    },
    {
      id: 12,
      name: "Call of Duty Warzone",
      yearsPlayed: ["2020", "2021", "2022", "2023"],
      releaseYear: "2020",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202306/2400/ac505d57a46e24dd96712263d89a150cb443af288c025ff2.jpg",
      link: "https://store.steampowered.com/app/1962663/Call_of_Duty_Warzone/"
    },
    {
      id: 13,
      name: "Saints Row IV",
      yearsPlayed: ["2020", "2023"],
      releaseYear: "2013",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/cdn/UP2047/CUSA01164_00/LqyA3sDAiQRkdxlVtnh6jxUYmQVL1J9S.png",
      link: "https://amzn.to/3DP9Hhp"
    },
    {
      id: 14,
      name: "Star Wars Jedi: Fallen Order",
      yearsPlayed: ["2020"],
      releaseYear: "2019",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/vulcan/img/rnd/202105/1714/WHeOu95nW2SZQy6H5IKgE2Bg.png",
      link: "https://amzn.to/40atXS0"
    },
    {
      id: 15,
      name: "Spyro Reignited Trilogy",
      yearsPlayed: ["2020", "2021"],
      releaseYear: "2018",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/cdn/UP0002/CUSA12125_00/wQimEr4XlJnBh9zJL6h8vwIoB919zvRy.png",
      link: "https://amzn.to/4gM4cyu"
    },
    {
      id: 16,
      name: "Bioshock Infinite",
      yearsPlayed: ["2020"],
      releaseYear: "2013",
      //image: "/covers/bioshockInfinite_cover.jpg",
      image: "https://cdn2.steamgriddb.com/grid/b937a56ac2082006f7b0a40ab60fe958.png",
      link: "https://amzn.to/4j3Mwjx"
    },
    {
      id: 17,
      name: "Detroit Become Human",
      yearsPlayed: ["2020"],
      releaseYear: "2018",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/vulcan/img/rnd/202010/2119/wl4DB5QGzlEHAXy1KLUVgOAu.png",
      link: "https://amzn.to/4j0eyMV"
    },
    {
      id: 18,
      name: "Fall Guys",
      yearsPlayed: ["2020", "2022"],
      releaseYear: "2020",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202408/0721/00dd43384a1ed60cd7453428dd5c6897b35b013d4b98965d.png",
      link: "https://store.playstation.com/en-us/product/UP1477-PPSA04476_00-FALLGUYS00000000"
    },
    {
      id: 19,
      name: "Osu",
      yearsPlayed: ["2020", "2021", "2023"],
      releaseYear: "2007",
      //image: "/covers/outlast_cover.jpg",
      image: "https://cdn2.steamgriddb.com/grid/64d532818f5a11ed28dfc6a1a7128060.png",
      link: "https://osu.ppy.sh/"
    },
    {
      id: 20,
      name: "Marvel's Avengers",
      yearsPlayed: ["2020"],
      releaseYear: "2020",
      //image: "/covers/outlast_cover.jpg",
      image: "https://upload.wikimedia.org/wikipedia/en/c/c0/Avengers_2020_cover_art.png",
      link: "https://amzn.to/4j8vZe1"
    },
    {
      id: 21,
      name: "F.E.A.R 2 Project Origin",
      yearsPlayed: ["2020"],
      releaseYear: "2009",
      //image: "/covers/outlast_cover.jpg",
      image: "https://cdn2.steamgriddb.com/grid/f94b4934affa82e613ce7f52777909b6.png",
      link: "https://store.steampowered.com/app/16450/FEAR_2_Project_Origin/"
    },
    {
      id: 22,
      name: "Old School Runescape",
      yearsPlayed: ["2020"],
      releaseYear: "2001",
      //image: "/covers/outlast_cover.jpg",
      image: "https://e.snmc.io/lk/l/x/b93b765725dfe50994567323656bda30/9577997",
      link: "https://store.steampowered.com/app/1343370/Old_School_RuneScape/"
    },
    {
      id: 23,
      name: "Five Nights at Freddy's",
      yearsPlayed: ["2020"],
      releaseYear: "2014",
      //image: "/covers/outlast_cover.jpg",
      image: "https://shared.cloudflare.steamstatic.com/store_item_assets/steam/apps/319510/ss_b5bf2127754d4e9bf6ab1c94e599d47f93a6708a.jpg",
      link: "https://amzn.to/3WbFYWi"
    },
    {
      id: 24,
      name: "Star Wars The Old Republic",
      yearsPlayed: ["2020", "2021", "2022"],
      releaseYear: "2011",
      //image: "/covers/outlast_cover.jpg",
      image: "https://gaming-cdn.com/images/products/9458/orig/star-wars-the-old-republic-pc-game-ea-app-cover.jpg?v=1705415061",
      link: "https://store.steampowered.com/app/1286830/STAR_WARS_The_Old_Republic/"
    },
    {
      id: 25,
      name: "Five Nights at Freddy's 2",
      yearsPlayed: ["2020"],
      releaseYear: "2014",
      //image: "/covers/outlast_cover.jpg",
      image: "https://cdn2.steamgriddb.com/grid/c4ad72391c45de1c5ffd124705a5fc74.png",
      link: "https://amzn.to/3WbFYWi"
    },
    {
      id: 26,
      name: "Destroy All Humans!",
      yearsPlayed: ["2020"],
      releaseYear: "2020",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202006/1809/RN0Ego9HLg4DmZMZSesFyWDy.png",
      link: "https://amzn.to/4acUD9A"
    },
    {
      id: 27,
      name: "Five Nights at Freddy's 3",
      yearsPlayed: ["2020"],
      releaseYear: "2015",
      //image: "/covers/outlast_cover.jpg",
      //image: "https://products.eneba.games/resized-products/8SHM05Cnozkenzo_tEflUWFAx3bsxURyGs3ZmSsBCkY_350x200_3x-0.jpeg",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTdfj9HSUqi85phIV-4Y_sh9s2JIp7F5IkW6A&s",
      link: "https://amzn.to/3WbFYWi"
    },
    {
      id: 28,
      name: "Street Fighter V",
      yearsPlayed: ["2020"],
      releaseYear: "2016",
      image: "https://image.api.playstation.com/vulcan/img/cfn/11307MTvkumhOsLQiA_3g0ZbFhLnHOOWVw3qR4Rum7sKAh8I3THtbG0aa-P7dF7-miXzo1ceqN897MfxYZ7Qx-GaEZs8kq4X.png",
      link: "https://amzn.to/4gLovMr"
    },
    {
      id: 29,
      name: "Star Wars Battlefront II",
      yearsPlayed: ["2020"],
      releaseYear: "2017",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202010/0612/v72etLvWWX27EAu0PU0qXtpD.png",
      link: "https://amzn.to/40pqtMU"
    },
    {
      id: 30,
      name: "The Dark Anthology: Little Hope",
      yearsPlayed: ["2020"],
      releaseYear: "2020",
      image: "https://cdn11.bigcommerce.com/s-xs1cevxe43/images/stencil/original/products/2049/9360/ECOM_Product_Tiles_Packshot_2D_AGNOSTIC_UNRATED_EN_USTDP_LH.jpg80__28608.1638491187.png?c=2",
      link: "https://amzn.to/4fOf51t"
    },
    {
      id: 31,
      name: "Ghost of Tsushima",
      yearsPlayed: ["2020"],
      releaseYear: "2020",
      image: "https://image.api.playstation.com/vulcan/img/rnd/202006/2518/quCEgXq4YjFYon3XFJjKG6Em.png",
      link: "https://amzn.to/3PuMTGl"
    },
    {
      id: 32,
      name: "Fallout 76",
      yearsPlayed: ["2020", "2024"],
      releaseYear: "2018",
      image: "https://static1.dualshockersimages.com/wordpress/wp-content/uploads/2018/06/Fallout76_E3_VaultSuit_1528639332.jpg",
      link: "https://amzn.to/408CBk1"
    },
    {
    id: 33,
    name: "Five Nights at Freddy's 4",
    yearsPlayed: ["2020"],
    releaseYear: "2015",
    //image: "/covers/outlast_cover.jpg",
    //image: "https://image.api.playstation.com/vulcan/img/cfn/11307lJXV6jMrabrKwzNFK94riCQC90Ogs2z0X1LWyX9oDA0W1zmbIw3V-eLTiw-q-kW_7MfwoEOQH-ZEVPPuRX1gDM0TYhw.png",
    image: "https://images.launchbox-app.com/93f90ac8-9cfe-49bc-b955-a346aec6a247.png",
    link: "https://amzn.to/3WbFYWi"
    },
    {
      id: 34,
      name: "Five Nights at Freddy's Sister Location",
      yearsPlayed: ["2020"],
      releaseYear: "2016",
      //image: "/covers/outlast_cover.jpg",
      image: "https://gamefaqs.gamespot.com/a/box/4/5/4/759454_front.jpg",
      link: "https://amzn.to/3WbFYWi"
    },
    {
      id: 35,
      name: "Freddy Fazbear's Pizzeria Simulator",
      yearsPlayed: ["2020"],
      releaseYear: "2017",
      //image: "/covers/outlast_cover.jpg",
      image: "https://preview.redd.it/u92ww84prnz51.png?width=1024&format=png&auto=webp&s=86a4fd415fffcd373509ba6899b14e935cbaad60",
      link: "https://store.steampowered.com/app/738060/Freddy_Fazbears_Pizzeria_Simulator/"
    },
    {
      id: 36,
      name: "Five Nights at Freddy's Help Wanted",
      yearsPlayed: ["2020"],
      releaseYear: "2019",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202311/1419/926257e09a1008437999159582acf05ae1a129401fe817d9.png",
      //image: "https://image.api.playstation.com/vulcan/ap/rnd/202009/3020/AwfxjgRsZUe9JK6AOvZcz8Rx.jpg",
      link: "https://amzn.to/4advMCj"
    },
    {
      id: 37,
      name: "Toontown Online",
      yearsPlayed: ["2020"],
      releaseYear: "2003",
      //image: "/covers/outlast_cover.jpg",
      image: "https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/11/toontown-online-video-game-cover-art-tag.jpg",
      link: "https://www.toontownrewritten.com/"
    },
    {
      id: 38,
      name: "Destiny 2",
      yearsPlayed: ["2020"],
      releaseYear: "2017",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/vulcan/img/rnd/202011/0400/3PetyfDv6TpzxVQtBKYnWq8o.png",
      link: "https://amzn.to/4fNxwDG"
    },
    {
      id: 39,
      name: "Kingdom Hearts III",
      yearsPlayed: ["2020"],
      releaseYear: "2019",
      //image: "/covers/outlast_cover.jpg",
      //image: "https://gamespot.com/a/uploads/original/1585/15855271/3440104-kh3_keyart_reveal_1200x1200.jpg",
      image: "https://image.api.playstation.com/vulcan/img/rnd/202010/3022/IVcZGcnea1Ba70VSWBQZdVJs.jpg",
      link: "https://amzn.to/3W9RMs8"
    },
    {
      id: 40,
      name: "World of Warcraft",
      yearsPlayed: ["2020"],
      releaseYear: "2004",
      //image: "/covers/outlast_cover.jpg",
      //image: "https://gamespot.com/a/uploads/original/1585/15855271/3440104-kh3_keyart_reveal_1200x1200.jpg",
      image: "https://cdna.artstation.com/p/assets/images/images/007/676/796/large/glenn-rane-bc-cover.jpg?1507783832",
      link: "https://amzn.to/3We2TjF"
    },
    {
      id: 41,
      name: "Worms Rumble",
      yearsPlayed: ["2020"],
      releaseYear: "2020",
      //image: "/covers/outlast_cover.jpg",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202010/1220/zoRNQGzwMQRJDpRSKjifE1vu.png",
      link: "https://amzn.to/3W4Lx8H"
    },
    {
      id: 42,
      name: "Elder Scrolls Online",
      yearsPlayed: ["2020"],
      releaseYear: "2014",
      //image: "/covers/outlast_cover.jpg",
      image: "https://cdn1.epicgames.com/offer/27aa2ebdcda14b3bb8a669aab73ca55f/EGS_TheElderScrollsOnline_ZeniMaxOnlineStudios_S2_1200x1600-5fc6dfa46dd3fe68292cd6b9ae75b0ee",
      //image: "https://image.api.playstation.com/vulcan/img/rnd/202010/2613/GwaZyAhG6cK3F6oefbJrZnou.png",
      link: "https://amzn.to/4j4GRd3"
    },
    {
      id: 43,
      name: "Dark Souls III",
      yearsPlayed: ["2021"],
      releaseYear: "2016",
      image: "https://m.media-amazon.com/images/M/MV5BMjg5MGI3ZWUtODc4NS00Y2E2LWE1MTQtZDAwM2Q4ZDJlNzg5XkEyXkFqcGc@._V1_.jpg",
      //image: "https://image.api.playstation.com/cdn/UP0700/CUSA03388_00/v8JlD8KcQUtTqaLBmpFnj1ESRR5zMkLk.png",
      link: "https://amzn.to/426zwDQ"
    },
    {
      id: 44,
      name: "Astro's Playroom",
      yearsPlayed: ["2021"],
      releaseYear: "2020",
      image: "https://i0.wp.com/powerup-gaming.com/wp-content/uploads/2020/11/astro-playroom-scaled.jpg?resize=1068%2C601&ssl=1",
      link: "https://store.playstation.com/en-us/product/IP9100-PPSA01325_00-PREINMASTER00000"
    },
    {
      id: 45,
      name: "Little Nightmares",
      yearsPlayed: ["2021"],
      releaseYear: "2017",
      image: "https://m.media-amazon.com/images/I/91HQ+aAlwTL._UF1000,1000_QL80_.jpg",
      link: "https://amzn.to/4a7B5Dk"
    },
    {
      id: 46,
      name: "Crash Bandicoot N Sane Trilogy",
      yearsPlayed: ["2021"],
      releaseYear: "2017",
      image: "https://assets.nintendo.com/image/upload/c_fill,w_1200/q_auto:best/f_auto/dpr_2.0/ncom/software/switch/70010000002090/ecfc64f339579b17ed8d12d5bdb4acd0cad2811cb2ff7dd0a02ce7e512c2d26a",
      link: "https://amzn.to/406nsQ7"
    },
    {
      id: 47,
      name: "Little Nightmares II",
      yearsPlayed: ["2021"],
      releaseYear: "2021",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202012/0311/21kgQxdCRRRWNRptsNutdCqU.jpg",
      link: "https://amzn.to/40b2vUe"
    },
    {
      id: 48,
      name: "The Strange Brigrade",
      yearsPlayed: ["2021"],
      releaseYear: "2018",
      image: "https://image.api.playstation.com/cdn/EP4529/CUSA07905_00/KOJaM0hGl3elKIuRmXnvhek9R75f8qvI.png",
      link: "https://amzn.to/3DMTAB3"
    },
    {
      id: 49,
      name: "The Last of Us",
      yearsPlayed: ["2021"],
      releaseYear: "2013",
      image: "https://m.media-amazon.com/images/I/71-hlREKk6L._AC_UF894,1000_QL80_.jpg",
      link: "https://amzn.to/4j9ZZ9q"
    },
    {
      id: 50,
      name: "Cuphead",
      yearsPlayed: ["2021"],
      releaseYear: "2017",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202206/0614/FD8wa2J2FZBuEAP2EtNd16sQ.png",
      link: "https://amzn.to/4h3UA1Z"
    },
    {
      id: 51,
      name: "It Takes Two",
      yearsPlayed: ["2021"],
      releaseYear: "2021",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202012/0815/0Xqi1LgRoEtJ5zlFprpd54Vu.png",
      link: "https://amzn.to/3DMX7z9"
    },
    {
      id: 52,
      name: "The Last of Us Part II",
      yearsPlayed: ["2021"],
      releaseYear: "2020",
      image: "https://blog.playstation.com/uploads/2024/01/76a2583e03ed46f0d63c50b9c347937d6a251a6a.jpeg",
      link: "https://amzn.to/40nPS9D"
    },
    {
      id: 53,
      name: "Spider-Man Miles Morales",
      yearsPlayed: ["2021"],
      releaseYear: "2020",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202008/1020/PRfYtTZQsuj3ALrBXGL8MjAH.jpg",
      link: "https://amzn.to/4gJZnpy"
    },
    {
      id: 54,
      name: "Final Fantasy XV",
      yearsPlayed: ["2021"],
      releaseYear: "2020",
      image: "https://image.api.playstation.com/cdn/UP0082/CUSA01633_00/kzdAiZGWkY7vPpmkRetq7MhOOvtrkGgW.png",
      link: "https://amzn.to/3PuP7Wd"
    },
    {
      id: 55,
      name: "Naruto to Boruto Shinobi Striker",
      yearsPlayed: ["2021", "2022"],
      releaseYear: "2018",
      image: "https://image.api.playstation.com/cdn/UP0700/CUSA08789_00/UYMVKoryxmjlsE6UPjhh0cKFRjyAJGa8.png",
      link: "https://amzn.to/421y8lT"
    },
    {
      id: 56,
      name: "Power Rangers: Battle For The Grid",
      yearsPlayed: ["2021"],
      releaseYear: "2019",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202103/1623/3TaCj4nqF8bL0SAmmRQbkpsS.png",
      link: "https://amzn.to/4fMOP7J"
    },
    {
      id: 57,
      name: "Outriders",
      yearsPlayed: ["2021"],
      releaseYear: "2021",
      image: "https://cdn1.epicgames.com/offer/c6e54ebd92da4ee8819c1c0956cebdc4/EGS_OUTRIDERSCOMPLETEEDITION_PeopleCanFly_Editions_S2_1200x1600-cd4429747b93cbdde8a5a5595ace8185",
      link: "https://amzn.to/422auFF"
    },
    {
      id: 58,
      name: "Resident Evil VII: Biohazard",
      yearsPlayed: ["2021"],
      releaseYear: "2021",
      //image: "https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/07/resident-evil-7-cover.jpg",
      image: "https://gugimages.s3.us-east-2.amazonaws.com/wp-content/uploads/2017/03/22173616/1473801329-resident-evil-7-biohazard-art.jpg",
      link: "https://store.playstation.com/en-us/product/UP0102-PPSA04400_00-BH70000000000001"
    },
    {
      id: 59,
      name: "Mass Effect Legendary Edition",
      yearsPlayed: ["2021", "2022"],
      releaseYear: "2021",
      image: "https://store-images.s-microsoft.com/image/apps.4132.14254372351363255.ac3906d1-13b6-4af0-a00a-e10c8a92007b.834fe893-324e-4c41-9740-bafed4026578",
      //image: "https://media.contentapi.ea.com/content/dam/masseffect/images/2020/10/mele-hero-large-keyart-16x9-xl.jpg.adapt.crop1x1.320w.jpg",
      link: "https://store.playstation.com/en-us/product/UP0006-CUSA19500_00-METR000000000000"
    },
    {
      id: 60,
      name: "A Plague Tale: Innocence",
      yearsPlayed: ["2021"],
      releaseYear: "2019",
      //image: "https://nichegamer.com/wp-content/uploads/2019/05/a-plague-tale-innocence-05-12-19-11.jpg",
      image: "https://cdna.artstation.com/p/assets/images/images/017/919/440/large/olivier-ponsonnet-boxart.jpg?1557849980",
      link: "https://store.playstation.com/en-us/product/UP4133-PPSA02388_00-APLAGUETALEGAME0"
    },
    {
      id: 62,
      name: "Yakuza 0",
      yearsPlayed: ["2021"],
      releaseYear: "2015",
      image: "https://m.media-amazon.com/images/M/MV5BZGMyMDBjZWMtMjFkNi00OWI1LWIyNmUtMDlkNDRiMjUyYWE2XkEyXkFqcGc@._V1_.jpg",
      link: "https://store.playstation.com/en-us/product/UP0177-CUSA05070_00-YAKUZA0AMERICA00"
    },
    {
      id: 63,
      name: "The Dark Anthology: House of Ashes",
      yearsPlayed: ["2021"],
      releaseYear: "2021",
      image: "https://cdn11.bigcommerce.com/s-xs1cevxe43/images/stencil/original/products/2500/9530/House_of_Ashes_blank__61673.1638485168.jpg?c=2",
      link: "https://store.steampowered.com/app/1281590/The_Dark_Pictures_Anthology_House_of_Ashes/"
    },
    {
      id: 64,
      name: "Crab Game",
      yearsPlayed: ["2021"],
      releaseYear: "2021",
      image: "https://m.media-amazon.com/images/M/MV5BYTE2ZDVmODktYTA0Mi00NjY4LWE2MjItY2QxNTA1MWE5OWZhXkEyXkFqcGc@._V1_.jpg",
      link: "https://store.steampowered.com/app/1782210/Crab_Game/"
    },
    {
      id: 65,
      name: "Psychonauts",
      yearsPlayed: ["2021"],
      releaseYear: "2005",
      image: "https://assets.doublefine.com/shared/games/backgrounds/psychonauts-portrait.jpg",
      link: ""
    },
    {
      id: 66,
      name: "Deep Rock Galactic",
      yearsPlayed: ["2022"],
      releaseYear: "2018",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202010/1516/oMdAma9i7zMCUAoeckoEP174.jpg",
      link: "https://store.playstation.com/en-us/product/UP4664-PPSA02967_00-DRGFULLGAMEPS5US"
    },
    {
      id: 67,
      name: "Assassin's Creed Valhalla",
      yearsPlayed: ["2022"],
      releaseYear: "2020",
      image: "https://m.media-amazon.com/images/I/81PYKLkWWLL._AC_UF1000,1000_QL80_.jpg",
      link: "https://store.playstation.com/en-us/product/UP0001-PPSA01491_00-GAME000000000000"
    },
    {
      id: 68,
      name: "Five Nights at Freddy's: Security Breach",
      yearsPlayed: ["2022", "2023"],
      releaseYear: "2021",
      image: "https://gmedia.playstation.com/is/image/SIEPDC/five-nights-at-freddys-security-breach-listing-thumb-01-en-14jan21?$facebook$",
      link: "https://store.playstation.com/en-us/product/UP0638-PPSA01797_00-FNAFSECUREBREACH"
    },
    {
      id: 69,
      name: "Halo Infinite",
      yearsPlayed: ["2022", "2023"],
      releaseYear: "2021",
      image: "https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/12/mixcollage-24-dec-2024-11-29-am-6627.jpg",
      link: "https://www.xbox.com/en-US/games/store/halo-infinite/9PP5G1F0C2B6/0010",
    },
    {
      id: 70,
      name: "The Mortuary Assistant",
      yearsPlayed: ["2022"],
      releaseYear: "2022",
      image: "https://m.media-amazon.com/images/M/MV5BMmM2NGIwODItYjZhZS00NDVhLTlmMGItZGEyNDg2ZmIzOGRkXkEyXkFqcGc@._V1_FMjpg_UX1000_.jpg",
      link: "https://store.steampowered.com/app/1295920/The_Mortuary_Assistant/"
    },
    {
      id: 71,
      name: "Poppy Playtime",
      yearsPlayed: ["2022", "2024"],
      releaseYear: "2022",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202310/2715/af66c0ac659a7a7c3e5d61c61dfdd74e73920ddaa95bde1f.jpg",
      link: "https://store.steampowered.com/app/1721470/Poppy_Playtime/"
    },
    {
      id: 72,
      name: "Spongebob Squarepants: Battle for Bikini Bottom",
      yearsPlayed: ["2022"],
      releaseYear: "2020",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202007/3122/W5DMW31LjfCHMdHUzbzXqA3H.jpg",
      link: "https://store.playstation.com/en-us/product/UP4389-CUSA14898_00-SPONGEBOBBFBBEU0"
    },
    {
      id: 73,
      name: "Marvel's Guardian of the Galaxy",
      yearsPlayed: ["2022"],
      releaseYear: "2021",
      image: "https://www.nme.com/wp-content/uploads/2021/10/marvels-guardians-galaxy-key-art-frame.jpg",
      link: "https://www.xbox.com/en-US/games/store/marvels-guardians-of-the-galaxy/9PGLL77C201J"
    },
    {
      id: 74,
      name: "Cuphead",
      yearsPlayed: ["2022"],
      releaseYear: "2017",
      image: "https://preview.redd.it/in0u8ufg8df41.jpg?width=1080&crop=smart&auto=webp&s=3f4b96f1a2db5e8394b356ae968d8405a3b1f08a",
      link: "https://store.steampowered.com/app/268910/Cuphead/"
    },
    {
      id: 75,
      name: "Elden Ring",
      yearsPlayed: ["2022", "2024"],
      releaseYear: "2022",
      image: "https://m.media-amazon.com/images/I/6110RSDn3PL.jpg",
      link: "https://store.steampowered.com/app/1245620/ELDEN_RING/"
    },
    {
      id: 76,
      name: "Call of Duty: Modern Warfare",
      yearsPlayed: ["2022"],
      releaseYear: "2019",
      image: "https://image.api.playstation.com/vulcan/img/rnd/202010/2320/i5l1jLAhFSTiO7lSCNDWjJ2J.jpg",
      link: "https://store.playstation.com/en-us/product/UP0002-CUSA08829_00-CODMWTHEGAME0001"
    },
    {
      id: 77,
      name: "Fallout 3",
      yearsPlayed: ["2022"],
      releaseYear: "2008",
      image: "https://thenerdstash.com/wp-content/uploads/2015/06/fallout-3.jpeg",
      link: "https://www.xbox.com/en-US/games/store/fallout-3/C29HQ887KH4B"
    },
    {
      id: 78,
      name: "Assassin's Creed II",
      yearsPlayed: ["2022"],
      releaseYear: "2009",
      image: "https://staticctf.ubisoft.com/J3yJr34U2pZ2Ieem48Dwy9uqj5PNUQTn/5q88N2Ij33R0pEUSRyiUDG/f837fab308b35b0fcb0c0716e38599b2/ac-2-heroBanner.jpg",
      link: "https://store.playstation.com/en-us/product/UP0001-CUSA05008_00-ACLEGACYHD000000"
    },
    {
      id: 80,
      name: "Stray",
      yearsPlayed: ["2022"],
      releaseYear: "2022",
      image: "https://adventuregamehotspot.com/images/games/6/383-stray-xbox-teaser.jpg",
      link: "https://store.playstation.com/en-us/product/UP2470-PPSA02100_00-STRAYSIEA0000000"
    },
    {
      id: 81,
      name: "Born Into Fear",
      yearsPlayed: ["2022"],
      releaseYear: "2022",
      image: "https://shared.fastly.steamstatic.com/store_item_assets/steam/apps/1705930/ss_e3064125f7c1d8316d9e120dad75fc07d0a53df7.1920x1080.jpg?t=1647884127",
      link: "https://store.steampowered.com/app/1705930/Born_Into_Fear/"
    },
    {
      id: 82,
      name: "We Happy Few",
      yearsPlayed: ["2022"],
      releaseYear: "2016",
      image: "https://www.superjumpmagazine.com/content/images/2023/07/i335276.jpeg",
      link: "https://www.xbox.com/en-US/games/store/we-happy-few/BPR2TBS2KMQJ/0001"
    },
    {
      id: 83,
      name: "Sly Cooper and the Thievious Racoonus",
      yearsPlayed: ["2022"],
      releaseYear: "2002",
      image: "https://m.media-amazon.com/images/M/MV5BODAxZjhiYTMtODJlNS00ZjM5LWJkYTUtMzc0YjBhN2ZkMmFkXkEyXkFqcGc@._V1_FMjpg_UX1000_.jpg",
      link: "https://store.playstation.com/en-us/product/UP9000-PPSA21300_00-SCUS971980000000"
    },
    {
      id: 84,
      name: "God of War Ragnarok",
      yearsPlayed: ["2022", "2023"],
      releaseYear: "2022",
      image: "https://external-preview.redd.it/IIciod7bABNjVmS4hT4h7px150nVQA7m5ig1377R4tM.png?format=pjpg&auto=webp&s=90bb4352eda17869a8ae5f12c9c7c097cca17716",
      link: "https://store.playstation.com/en-us/product/UP9000-PPSA08329_00-GOWRAGNAROK00000"
    },
    {
      id: 85,
      name: "Assassin's Creed Brotherhood",
      yearsPlayed: ["2022"],
      releaseYear: "2010",
      image: "https://static1.thegamerimages.com/wordpress/wp-content/uploads/2024/07/assassin-s-creed-brotherhood-cover.jpg",
      link: "https://store.playstation.com/en-us/product/UP0001-CUSA05008_00-ACLEGACYHD000000"
    },
    {
      id: 86,
      name: "Grounded",
      yearsPlayed: ["2022"],
      releaseYear: "2022",
      image: "https://assets.xboxservices.com/assets/85/45/8545cde4-e097-412a-b95e-3870a2d23d32.jpg?n=Grounded_GLP-Page-Hero-0_1083x1222.jpg",
      link: "https://www.xbox.com/en-US/games/grounded"
    },
    {
      id: 87,
      name: "The Stanley Parable: Ultra Deluxe",
      yearsPlayed: ["2022"],
      releaseYear: "2022",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202203/2023/T4HUZHzWw6fDKyNBxHMcMGmF.png",
      link: "https://store.playstation.com/en-us/product/UP3613-PPSA06654_00-6644681382731206"
    },
    {
      id: 88,
      name: "Happy's Humble Burger Farm",
      yearsPlayed: ["2022"],
      releaseYear: "2021",
      image: "https://image.api.playstation.com/vulcan/img/rnd/202111/1618/bMWfY9CGGxWCAt3zPdpjpYBc.png",
      link: "https://store.steampowered.com/app/1433340/Happys_Humble_Burger_Farm/"
    },
    {
      id: 89,
      name: "Sly 2: Band of Thieves",
      yearsPlayed: ["2022", "2023"],
      releaseYear: "2004",
      image: "https://gamefaqs.gamespot.com/a/review/70/169570-4.jpg",
      link: "https://store.playstation.com/en-us/product/UP9000-PPSA22287_00-SCUS973160000000"
    },
    {
      id: 90,
      name: "Resident Evil VIII: Village",
      yearsPlayed: ["2022"],
      releaseYear: "2022",
      image: "https://products.eneba.games/resized-products/hvKCG93Orn7ypAy8hHis7mtUrWu8u1OwJz7u4uydchs_350x200_3x-0.jpeg",
      link: "https://store.playstation.com/en-us/product/UP0102-PPSA01556_00-VILLAGEFULLGAMEX"
    },
    {
      id: 91,
      name: "The Dark Anthology: The Devil In Me",
      yearsPlayed: ["2022"],
      releaseYear: "2022",
      image: "https://cdn11.bigcommerce.com/s-xs1cevxe43/images/stencil/original/products/2658/11858/TDIM__26181.1669130981.jpg?c=2",
      link: "https://store.bandainamcoent.com/the-dark-pictures-anthology-the-devil-in-me-standard-edition-steam/https://store.bandainamcoent.com/the-dark-pictures-anthology-the-devil-in-me-standard-edition-steam/https://store.bandainamcoent.com/the-dark-pictures-anthology-the-devil-in-me-standard-edition-steam/"
    },
    {
      id: 92,
      name: "Monster Hunter Rise",
      yearsPlayed: ["2023", "2024"],
      releaseYear: "2021",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202211/1504/KzeHCTuoWLV4Cl7wkDA2YwCo.png",
      link: "https://www.xbox.com/en-US/games/store/monster-hunter-rise/9N1VP8WDQK4D"
    },
    {
      id: 93,
      name: "Demon Slayer: Hinokami Chronicles",
      yearsPlayed: ["2023", "2024"],
      releaseYear: "2022",
      image: "https://pbs.twimg.com/media/FkCVQuJVEAANhSQ?format=jpg&name=4096x4096",
      link: "https://store.playstation.com/en-us/product/UP0177-PPSA03489_00-HINOKAMI00000000"
    },
    {
      id: 94,
      name: "Hogwarts Legacy",
      yearsPlayed: ["2023"],
      releaseYear: "2021",
      image: "https://cdn1.epicgames.com/offer/e97659b501af4e3981d5430dad170911/EGS_HogwartsLegacyDigitalDeluxeEdition_AvalancheSoftware_Editions_S2_1200x1600-eb5c42c97eb3f0ed444e58114a0c30b9",
      //image: "https://i.redd.it/potn7vwaxyj91.png",
      link: "https://www.xbox.com/en-US/games/hogwarts-legacy"
    },
    {
      id: 95,
      name: "Wo Long: Fallen Dynasty",
      yearsPlayed: ["2023"],
      releaseYear: "2023",
      image: "https://preview.redd.it/art-wo-long-fallen-dynasty-complete-edition-v0-1aasgeuvmybc1.jpeg?auto=webp&s=7a6af64b5470c2507af60a86be6a4a60217a2ae7",
      link: "https://www.xbox.com/en-US/games/store/wo-long-fallen-dynasty/9N9X9PC8V9CP"
    },
    {
      id: 96,
      name: "The Simpsons: Hit & Run",
      yearsPlayed: ["2023"],
      releaseYear: "2003",
      image: "https://cdn2.steamgriddb.com/grid/a44fbda1d66caf7a6cb788e21c3c5511.png",
      //image: "https://prod-static.mobilesyrup.com/uploads/2023/07/the-simpsons-hit-and-run-scaled.jpg",
      link: "https://www.amazon.com/s?k=the+simpsons+hit+and+run&crid=QMVZYA9Q1WAU&sprefix=the+simpsons+hit+and+run%2Caps%2C174&ref=nb_sb_noss_1"
    },
    {
      id: 97,
      name: "Halo: Master Chief Collection",
      yearsPlayed: ["2023", "2024"],
      releaseYear: "2014",
      image: "https://store-images.s-microsoft.com/image/apps.13367.13817186670444302.148c432a-9fce-4c7d-bf13-8a2bd3a527b3.f26b74f0-8b1f-41eb-a82f-06843ec33473",
      link: "https://www.xbox.com/en-US/games/halo-the-master-chief-collection"
    },
    {
      id: 98,
      name: "LEGO Star Wars: The Skywalker Saga",
      yearsPlayed: ["2023"],
      releaseYear: "2022",
      image: "https://store-images.s-microsoft.com/image/apps.15663.13677920620920924.f0d2262f-b971-4299-914b-194791cb9c5b.ce64672f-e040-481c-a781-28a49b0ecf6e",
      link: "https://www.xbox.com/en-US/games/store/lego-star-wars-the-skywalker-saga/9njn1mc1x5fk"
    },
    {
      id: 99,
      name: "Gears of War: Ultimate Edition",
      yearsPlayed: ["2023"],
      releaseYear: "2015",
      image: "https://cdn.gearsofwar.com/gearsofwar/sites/2/2024/09/gears-of-war-ultimate-edition-2000x2000-5e546349767f3-66d77b3621fdc.jpg",
      link: "https://www.xbox.com/en-US/games/store/gears-of-war-ultimate-edition/BQT21VXFS52F/0001"
    },
    {
      id: 100,
      name: "High on Life",
      yearsPlayed: ["2023"],
      releaseYear: "2022",
      image: "https://cdn1.epicgames.com/spt-assets/8ae3e6daa99b4f54aa17551d1818571f/download-high-on-life-offer-3j8wt.jpg",
      link: "https://www.xbox.com/en-US/games/store/high-on-life/9NL4714VTLRS"
    },
    {
      id: 101,
      name: "We Were Here",
      yearsPlayed: ["2023"],
      releaseYear: "2017",
      image: "https://m.media-amazon.com/images/M/MV5BNzliYmYwYzItZTBkMy00ZjVhLWJkNWQtMmVhMjZkNDkxMGMyXkEyXkFqcGc@._V1_.jpg",
      link: "https://store.steampowered.com/app/582500/We_Were_Here/"
    },
    {
      id: 102,
      name: "Dead Space",
      yearsPlayed: ["2023"],
      releaseYear: "2023",
      image: "https://i.redd.it/xdiokxacfnr91.jpg",
      link: "https://store.playstation.com/en-us/product/UP0006-PPSA03845_00-BEYONDPS5GAME000"
    },
    {
      id: 103,
      name: "The Legend of Zelda: Breath of the Wild",
      yearsPlayed: ["2023"],
      releaseYear: "2017",
      image: "https://i.redd.it/awl2w7ox6icy.jpg",
      link: "https://www.nintendo.com/us/store/products/the-legend-of-zelda-breath-of-the-wild-switch/"
    },
    {
      id: 104,
      name: "Fate",
      yearsPlayed: ["2023"],
      releaseYear: "2005",
      image: "https://assets-prd.ignimgs.com/2024/01/16/fate-1705437458623.jpg",
      link: "https://store.steampowered.com/app/246840/FATE/"
    },
    {
      id: 105,
      name: "Slender: The Arrival",
      yearsPlayed: ["2023"],
      releaseYear: "2013",
      image: "https://cdn1.epicgames.com/spt-assets/4f2537e2a2124cdd8fbd18b7068167d9/slender-the-arrival-4rvfj.png",
      link: "https://store.steampowered.com/app/252330/Slender_The_Arrival/"
    },
    {
      id: 106,
      name: "Batman Arkham Origins",
      yearsPlayed: ["2023"],
      releaseYear: "2013",
      image: "https://dcanimated.com/WF/sections/releases/games/arkhamorigins/keyart.jpg",
      link: "https://store.steampowered.com/app/209000/Batman_Arkham_Origins/"
    },
    {
      id: 107,
      name: "My Hero Ultra Rumble",
      yearsPlayed: ["2023", "2024"],
      releaseYear: "2023",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202309/0620/3bef6a2dd8ce4552a75a5f06674f940d328fc9cf650dc47b.png",
      link: "https://store.playstation.com/en-us/product/UP0700-CUSA27946_00-HEROVSGAME000000"
    },
    {
      id: 108,
      name: "Street Fighter 6",
      yearsPlayed: ["2023"],
      releaseYear: "2023",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202211/1502/nJRClRE03L3zkW79AciWq9rO.jpg",
      link: "https://www.xbox.com/en-US/games/store/street-fighter-6/9NM79B7N9JM6"
    },
    {
      id: 109,
      name: "Star Wars Jedi: Survivor",
      yearsPlayed: ["2023"],
      releaseYear: "2023",
      image: "https://i.redd.it/745nvgdjk0xa1.jpg",
      link: "https://store.playstation.com/en-us/product/UP0006-PPSA07783_00-APPLEJACKGAME000"
    },
    {
      id: 110,
      name: "Telltale's The Walking Dead: Definitive Edition",
      yearsPlayed: ["2023", "2024"],
      releaseYear: "2012",
      image: "https://m.media-amazon.com/images/M/MV5BMWFhN2RlMjgtOWQ1NC00MGRlLWIwYzItNmNiZmQwOWJjMzJhXkEyXkFqcGc@._V1_.jpg",
      link: "https://www.xbox.com/en-US/games/store/the-walking-dead-the-telltale-definitive-series/9PPDLH53M8PM"
    },
    {
      id: 111,
      name: "Starfield",
      yearsPlayed: ["2023"],
      releaseYear: "2023",
      image: "https://pbs.twimg.com/media/F3vUL8-bAAE-zvi.jpg:large",
      link: "https://www.xbox.com/en-US/games/store/starfield/9NCJSXWZTP88/0010"
    },
    {
      id: 112,
      name: "Lies of P",
      yearsPlayed: ["2023", "2024"],
      releaseYear: "2023",
      image: "https://media.nichegamer.com/wp-content/uploads/2023/09/lies-of-p-09-13-23-2-1.jpg",
      link: "https://www.xbox.com/en-US/games/store/lies-of-p/9PCM4CMTPPGC"
    },
    {
      id: 113,
      name: "Payday 3",
      yearsPlayed: ["2023"],
      releaseYear: "2023",
      image: "https://cdn.wccftech.com/wp-content/uploads/2023/07/payday3-HD-scaled.jpg",
      link: "https://www.xbox.com/en-US/games/store/payday-3/9NPZVDCH73SX/0010"
    },
    {
      id: 114,
      name: "Assassin's Creed Mirage",
      yearsPlayed: ["2023"],
      releaseYear: "2023",
      image: "https://preview.redd.it/assassins-creed-mirage-cover-art-assassins-creed-2007-style-v0-h5plbuhszwqa1.png?width=1587&format=png&auto=webp&s=4dcee7a226b30c97671928f35518dfd7c3ce5ae9",
      link: "https://store.playstation.com/en-us/product/UP0001-PPSA07230_00-EDITIONSTANDARD0"
    },
    {
      id: 115,
      name: "Spider-Man 2",
      yearsPlayed: ["2023"],
      releaseYear: "2023",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202306/1219/60eca3ac155247e21850c7d075d01ebf0f3f5dbf19ccd2a1.jpg",
      link: "https://store.playstation.com/en-us/product/UP9000-PPSA03016_00-MARVELSPIDERMAN2"
    },
    {
      id: 116,
      name: "Martha Is Dead",
      yearsPlayed: ["2023"],
      releaseYear: "2022",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202201/0716/uUBbCdrypnZgaDygBk1R0fsx.jpg",
      link: "https://www.xbox.com/en-US/games/store/martha-is-dead/9PM6SJBMVQZL/0010"
    },
    {
      id: 117,
      name: "September 7th",
      yearsPlayed: ["2023"],
      releaseYear: "2023",
      image: "https://howlongtobeat.com/games/120815_September_7th.jpg?width=250",
      link: "https://store.steampowered.com/app/2249160/September_7th/"
    },
    {
      id: 118,
      name: "The Outlast Trials",
      yearsPlayed: ["2023"],
      releaseYear: "2023",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202312/2121/a2a4f9926e82836152e76444800790bc41046edf31602a40.png",
      link: "https://store.steampowered.com/app/1304930/The_Outlast_Trials/"
    },
    {
      id: 119,
      name: "Fortnite",
      yearsPlayed: ["2023"],
      releaseYear: "2017",
      image: "https://m.media-amazon.com/images/M/MV5BMTZlMmIxM2EtN2Y4Zi00M2ZhLTk3NzgtNjJmZTU0MTQ3YjcwXkEyXkFqcGc@._V1_FMjpg_UX1000_.jpg",
      link: "https://store.playstation.com/en-us/product/UP1477-PPSA01922_00-FNBNDL0000000000"
    },
    {
      id: 120,
      name: "Destroy All Humans 2 Reprobed",
      yearsPlayed: ["2023"],
      releaseYear: "2022",
      image: "https://cdn.wccftech.com/wp-content/uploads/2021/09/DAH2_keyart-scaled.jpg",
      link: "https://store.playstation.com/en-us/product/UP4389-PPSA05398_00-DAH2REPRODBEDUS0"
    },
    {
      id: 121,
      name: "Sekiro",
      yearsPlayed: ["2023", "2024"],
      releaseYear: "2019",
      image: "https://image.api.playstation.com/vulcan/img/rnd/202010/1700/B66T6RbAfvIGjpEQxPq7k0Mu.png",
      link: "https://www.xbox.com/en-US/games/store/sekiro-shadows-die-twice-goty-edition/BQD5WRRP2D6Q/0001"
    },
    {
      id: 122,
      name: "Helldivers 2",
      yearsPlayed: ["2024"],
      releaseYear: "2023",
      image: "https://gaming-cdn.com/images/products/16121/orig/helldivers-2-playstation-5-game-playstation-store-cover.jpg?v=1730296215",
      link: "https://store.playstation.com/en-us/product/UP9000-PPSA01413_00-HELLDIVERS200000"
    },
    {
      id: 123,
      name: "Mafia: Definitive Edition",
      yearsPlayed: ["2024"],
      releaseYear: "2020",
      image: "https://cdn2.unrealengine.com/Diesel%2Fproductv2%2Fmafia-definitive-edition%2Fhome%2FEGS_MafiaDefinitiveEditionPreOrder_Hangar13_G1A_00-1920x1080-e7457132d8ebeb06c2d663944087c683e4834918.jpg",
      link: "https://store.playstation.com/en-us/product/UP1001-CUSA18097_00-MAFIAONEREMASTER"
    },
    {
      id: 124,
      name: "Assassin's Creed Revelations",
      yearsPlayed: ["2024"],
      releaseYear: "2011",
      image: "https://i.ebayimg.com/images/g/EGwAAOSw-oFkUy8q/s-l1200.jpg",
      link: "https://store.playstation.com/en-us/product/UP0001-CUSA05008_00-ACLEGACYHD000000"
    },
    {
      id: 125,
      name: "Red Dead Redemption II",
      yearsPlayed: ["2024"],
      releaseYear: "2018",
      image: "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/e5d6f175-3a2e-493d-b7f2-5f70852b4f2e/deuawyw-04ca2264-bda4-448f-a0c1-405186a13899.jpg/v1/fill/w_683,h_1171,q_70,strp/red_dead_redemption_2_arthur_morgan_and_the_gang_by_love_myart_deuawyw-pre.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MjE5NSIsInBhdGgiOiJcL2ZcL2U1ZDZmMTc1LTNhMmUtNDkzZC1iN2YyLTVmNzA4NTJiNGYyZVwvZGV1YXd5dy0wNGNhMjI2NC1iZGE0LTQ0OGYtYTBjMS00MDUxODZhMTM4OTkuanBnIiwid2lkdGgiOiI8PTEyODAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.gCDuNDEGqMdAHDHPtFu18Z0FKiBrtuKVW8yBnRQ1aeM",
      link: "https://store.playstation.com/en-us/product/UP1004-CUSA03041_00-REDEMPTIONFULL02"
    },
    {
      id: 126,
      name: "For Honor",
      yearsPlayed: ["2024"],
      releaseYear: "2017",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202402/2911/c575e6ec4aaeb0dbf047788725382ab3ce814c4931dc8e9c.jpg",
      link: "https://www.xbox.com/en-US/games/store/for-honor/9N3DWR830CVN/0010"
    },
    {
      id: 127,
      name: "XDefiant",
      yearsPlayed: ["2024"],
      releaseYear: "2024",
      image: "https://m.economictimes.com/thumb/msid-109412477,width-1600,height-900,resizemode-4,imgsize-67354/xdefiant-server-test-session-this-is-what-we-know-so-far.jpg",
      link: "https://store.playstation.com/en/concept/10002211"
    },
    {
      id: 128,
      name: "Fears to Fathom: Northwood Hitchhike",
      yearsPlayed: ["2024"],
      releaseYear: "2022",
      image: "https://m.media-amazon.com/images/M/MV5BMmE1MzE3NjctMWM4YS00MGJlLTkxOGUtMjEwMjQ3N2RmMGVhXkEyXkFqcGc@._V1_.jpg",
      link: "https://store.steampowered.com/app/1763050/Fears_to_Fathom__Norwood_Hitchhike/"
    },
    {
      id: 129,
      name: "Fears to Fathom: Ironbark Lookout",
      yearsPlayed: ["2024"],
      releaseYear: "2024",
      image: "https://m.media-amazon.com/images/M/MV5BOWQ3ZTA0YTEtMDhhYy00ZmZiLTg2MjEtNWQxOWE1Nzc2ZDAwXkEyXkFqcGc@._V1_.jpg",
      link: "https://store.steampowered.com/app/2506160/Fears_to_Fathom__Ironbark_Lookout/"
    },
    {
      id: 130,
      name: "Fears to Fathom: Carson House",
      yearsPlayed: ["2024"],
      releaseYear: "2023",
      image: "https://m.media-amazon.com/images/M/MV5BNGZjOTBlYTctODcxNy00YTM1LTg2YTYtZTI3NzBmMDA4ZmJmXkEyXkFqcGc@._V1_.jpg",
      link: "https://store.steampowered.com/app/2120900/Fears_to_Fathom__Carson_House/"
    },
    {
      id: 131,
      name: "Sifu",
      yearsPlayed: ["2024"],
      releaseYear: "2022",
      image: "https://cdn1.epicgames.com/offer/b7b42e2078524ab386a8b2a9856ef557/EGS_SIFUStandardEdition_Sloclap_S4_1200x1600-32aca69d756abfcc25f8581942a6162b_1200x1600-32aca69d756abfcc25f8581942a6162b",
      link: "https://store.playstation.com/en-us/product/UP2703-PPSA05132_00-4856299050197748"
    },
    {
      id: 132,
      name: "Assassin's Creed III Remastered",
      yearsPlayed: ["2024"],
      releaseYear: "2012",
      image: "https://cdn1.epicgames.com/offer/anise/AC3Remastered_Store_Portrait_1200x1600_1200x1600-9c929e1f34aac0f0a40fc4b708f53951",
      link: "https://store.playstation.com/en-us/product/UP0001-CUSA11711_00-AC3GAMEPS4000001"
    },
    {
      id: 133,
      name: "Black Myth Wukong",
      yearsPlayed: ["2024"],
      releaseYear: "2024",
      image: "https://i.redd.it/ymm36cwov2ld1.png",
      link: "https://store.playstation.com/en-us/product/HP6545-PPSA23226_00-GAME000000000000"
    },
    {
      id: 134,
      name: "Star Wars Outlaws",
      yearsPlayed: ["2024"],
      releaseYear: "2024",
      image: "https://lumiere-a.akamaihd.net/v1/images/outlaws-key-art-main-02_e3c5cd6c.jpeg?region=0,0,1024,1024",
      link: "https://www.xbox.com/en-US/games/store/star-wars-outlaws/9P87S3NP6SR2"
    },
    {
      id: 135,
      name: "Chuxie",
      yearsPlayed: ["2024"],
      releaseYear: "2024",
      image: "https://mediaproxy.tvtropes.org/width/1200/https://static.tvtropes.org/pmwiki/pub/images/chuxx.png",
      link: "https://store.steampowered.com/app/2969160/CHUXIE/"
    },
    {
      id: 136,
      name: "Five Nights at Freddy's Into the Pit",
      yearsPlayed: ["2024"],
      releaseYear: "2024",
      image: "https://m.media-amazon.com/images/M/MV5BZmI0NjIyMTYtM2I5MS00ZjU4LTg2ZmMtM2NkYmFhZWYzNjcwXkEyXkFqcGc@._V1_.jpg",
      link: "https://store.steampowered.com/app/2638370/Five_Nights_at_Freddys_Into_the_Pit/"
    },
    {
      id: 137,
      name: "Another Crab's Treasure",
      yearsPlayed: ["2024"],
      releaseYear: "2024",
      image: "https://upload.wikimedia.org/wikipedia/en/0/01/Another_Crab%27s_Treasure_poster.webp",
      link: "https://store.playstation.com/en-us/product/UP7131-PPSA20422_00-ANOTHERCRABS4US5"
    },
    {
      id: 138,
      name: "Dragonball Sparking! Zero",
      yearsPlayed: ["2024"],
      releaseYear: "2024",
      image: "https://image.api.playstation.com/vulcan/ap/rnd/202405/2216/cbb03393f0ab1149f2b89a8194ce19e596a24fa5bec6526a.png",
      link: "https://store.playstation.com/en-us/product/UP0700-PPSA15211_00-DRAGONBALLSPARK0"
    },
    {
      id: 139,
      name: "Doki Doki Literature Club!",
      yearsPlayed: ["2024"],
      releaseYear: "2017",
      image: "https://cdn1.epicgames.com/salesEvent/salesEvent/EGS_DokiDokiLiteratureClubPlus_TeamSalvato_S2_1200x1600-9c6fa6ac4b26e9ad4fb0d3e35797dcac",
      link: "https://store.playstation.com/en-us/product/UP0604-PPSA03732_00-DOKIDOKILITCLUBP"
    },
    {
      id: 140,
      name: "The Classrooms",
      yearsPlayed: ["2024"],
      releaseYear: "2022",
      image: "https://shared.cloudflare.steamstatic.com/store_item_assets/steam/apps/2099110/header.jpg?t=1738752037",
      //image: "https://shared.akamai.steamstatic.com/store_item_assets/steam/apps/2099110/header.jpg?t=1729526854",
      link: "https://store.steampowered.com/app/2099110/The_Classrooms/"
    },
    {
      id: 141,
      name: "Fears to Fathom: Woodbury Getaway",
      yearsPlayed: ["2024"],
      releaseYear: "2024",
      image: "https://m.media-amazon.com/images/M/MV5BNTBlYTk3OGMtYTEzMi00NTM1LWIxNTEtZGFjMDlmYzdlMmRhXkEyXkFqcGc@._V1_.jpg",
      link: "https://store.steampowered.com/app/2961530/Fears_to_Fathom__Woodbury_Getaway/"
    },
    {
      id: 142,
      name: "Escape The Backrooms",
      yearsPlayed: ["2024"],
      releaseYear: "2022",
      image: "https://static0.gamerantimages.com/wordpress/wp-content/uploads/2024/12/mixcollage-10-dec-2024-07-34-pm-3390.jpg",
      link: "https://store.steampowered.com/app/1943950/Escape_the_Backrooms/"
    },
    {
      id: 143,
      name: "Watch Dogs 2",
      yearsPlayed: ["2024"],
      releaseYear: "2024",
      //image: "https://image.api.playstation.com/cdn/UP0001/CUSA04459_00/qBxvfDJJ9dbavai6xsWOcWaxRDGRb7h0.png",
      image: "https://smartcdn.gprod.postmedia.digital/financialpost/wp-content/uploads/2016/11/wd25-e1479104909488.jpg",
      link: "https://store.playstation.com/en-us/product/UP0001-CUSA04459_00-WD2FULLGAME00000"
    },
    {
      id: 144,
      name: "Marvel Rivals",
      yearsPlayed: ["2024"],
      releaseYear: "2024",
      image: "https://blog.playstation.com/uploads/2024/12/464ca49c88916fbdb96def8a57e2734eb94fa914.jpeg",
      link: "https://store.playstation.com/en-us/product/UB0335-PPSA21669_00-0320312678245089"
    },
];